<template>
  <i-modal v-model="inputValue">
    <template #header>
      What to do with the changed data
    </template>
    <div
      class="_display:flex _justify-content:space-between"
      am-changed-part-buttons
    >
      <i-button @click="emit('delete')">Delete</i-button>
      <i-button color="primary" @click="emit('save')" :disabled="isDisabled">Save</i-button>
    </div>
  </i-modal>
</template>

<script setup>
import { computed, onMounted, onUnmounted, defineEmits, defineProps } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const emit = defineEmits(['update:modelValue'])
const prop = defineProps({
  isShowWarning: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
})
const inputValue = computed({
  get () {
    return prop.isShowWarning
  },
  set (val) {
    emit('update:modelValue', val)
  }
})
const close = () => {
  emit('update:modelValue', false)
}
onMounted(() => {
  store.commit('ui/closeModal', close)
})
onUnmounted(() => {
  store.commit('ui/closeModal', null)
})
</script>
